// Uclean-Admin-Dashboard/src/mocks/promo/promotions/store.js
// Mutable in-memory store so create/update/delete "stick" within a session.

import fixtures from './fixtures.json';

export let promotionsStore = [...fixtures];

export const _resetPromotionsStore = () => {
  promotionsStore = [...fixtures];
};

export const findPromotion = (id) => promotionsStore.find((p) => p.id === id);
